const inviteSignup = {
  toastr: 'Convite enviado',
  toastr1: 'O convite foi enviado com sucesso`'
};

export default inviteSignup;
